import { MdAdd, MdClose } from 'react-icons/md';
import FormInput from '../../../components/forms/input';
import type { PartyEntry } from '../../types';

interface PartyFieldsProps {
    entries: PartyEntry[];
    errors?: Record<string, string>[];
    onUpdate: (i: number, field: keyof PartyEntry, value: string) => void;
    onRemove: (i: number) => void;
    onAdd: () => void;
    nameLabel: string;
    addLabel: string;
}

export default function PartyFields({
    entries,
    errors,
    onUpdate,
    onRemove,
    onAdd,
    nameLabel,
    addLabel,
}: PartyFieldsProps) {
    return (
        <div className="space-y-4">
            {entries.map((entry, i) => {
                const entryErrors = errors?.[i] || {};
                return (
                    <div key={i} className="space-y-4 bg-[#F7F7F7] p-4 rounded-lg border border-[#E0E0E0]">
                        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                            <FormInput
                                title={i === 0 ? nameLabel : `${nameLabel} ${i + 1}`}
                                id={`p-name-${i}`}
                                placeholder="e.g  Adebayo Oluwaseun Johnson"
                                value={entry.name}
                                onChange={(e) => onUpdate(i, 'name', e.target.value)}
                                variant="white"
                                error={entryErrors.name}
                            />
                            <FormInput
                                title="Address"
                                id={`p-addr-${i}`}
                                placeholder="House number, street, area, city, state"
                                value={entry.address}
                                onChange={(e) => onUpdate(i, 'address', e.target.value)}
                                variant="white"
                                error={entryErrors.address}
                            />
                            <FormInput
                                title="Phone Number"
                                id={`p-phone-${i}`}
                                placeholder="e.g. +234 801 234 5678"
                                value={entry.phone}
                                onChange={(e) => onUpdate(i, 'phone', e.target.value)}
                                variant="white"
                                error={entryErrors.phone}
                            />
                            <FormInput
                                title="Email"
                                id={`p-email-${i}`}
                                type="email"
                                placeholder="e.g.  yourmail@mail.com"
                                value={entry.email}
                                onChange={(e) => onUpdate(i, 'email', e.target.value)}
                                variant="white"
                                error={entryErrors.email}
                            />
                        </div>
                        {i === entries.length - 1 && (
                            <div className="flex flex-wrap items-center gap-3 justify-start">
                                <button
                                    type="button"
                                    onClick={onAdd}
                                    className="flex items-center justify-center gap-2 rounded-lg bg-[#E0E0E0] border border-[#eee] px-6 py-3 text-[13px] font-semibold text-secondary transition-colors hover:bg-[#E0E0E0]/70"
                                >
                                    <MdAdd size={18} />
                                    {addLabel}
                                </button>
                                {entries.length > 1 && (
                                    <button
                                        type="button"
                                        onClick={() => onRemove(i)}
                                        className="w-[200px] flex items-center justify-center bg-[#f8dee1] gap-2 rounded-lg border border-[#FF4E64] px-6 py-3 text-[13px] font-semibold text-red-600 transition-colors hover:bg-red-50"
                                    >
                                        <MdClose size={18} />
                                        Remove
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
